export const PROJECT_TABLE_MAP_CONFIG = {
    name            : 'Map',
    menuName        : 'Map',
    icon            : 'i5-map',
    // iconLight       : 'i5-table-light',
    image           : 'table',
    iconSvg         : 'isvg-view-map',
    url             : 'map',
    stringId        : 'tasks_map',
    description     : 'Interactive map view with task locations based on the custom address field.',
    inheritance     : true,
    hasTemplates    : true,
}
